import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, map, Observable, of, switchMap } from 'rxjs';
import { Resume } from '../../models/resume';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
import { selectsessionId } from '../../storage/resume.selectors';
import { AuthService } from '@app/services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class OrquestadorInquilinoService {

  private baseUrl: string = environment.URL_MULESOFT_ORQUESTADOR_INQUILINO;
  


  // variables de para consumo de Lease_orchesResumesTenant
  

  constructor(private http: HttpClient,
    private store: Store,
    private authService: AuthService) { }




  /**
 * Realiza una petición POST con autenticación automática y validaciones específicas para Lease_orchesResumesTenant
 * @param body - Cuerpo de la petición
 * @param url - URL específica para la petición (opcional, usa baseUrl por defecto)
 * @returns Observable con la respuesta validada
 */
  private makeAuthenticatedRequestWithValidation<T>(body: any, url?: string): Observable<T | { error: boolean; message: any; status: any }> {
    const requestUrl = url || this.baseUrl;

    return this.authService.createAuthHeaders().pipe(
      switchMap(headers => {
        const requestBody = JSON.stringify(body);
        const parsedBody = JSON.parse(requestBody);
        console.log('body tenant', body);

        return this.http.post<any>(requestUrl, parsedBody, { headers, observe: 'response' }).pipe(
          map(response => {
            if (response && response.body.data && response.body.error === false) {
              return response.body.data;
            } else if (response.body.error === true) {
              throw { error: true, message: response.body.data.message || response.body.data.Reason, status: response.status };
            } else {
              return response;
            }
          }),
          catchError(error => {
            const errorMessage = error.message || error.Reason || 'Unknown';
            return of({ error: true, message: errorMessage, status: error.status });
          })
        );
      }),
      catchError(error => {
        console.error('Error in authenticated request:', error);
        return of({ error: true, message: error.message || 'Unknown error', status: error.status || 500 });
      })
    );
  }

  /**
   * Método principal para consumir el servicio de inquilino
   * @param body - Cuerpo de la petición
   * @param ParamsessionId - ID de sesión (opcional)
   * @returns Observable con la respuesta
   */
  public Lease_orchesResumesTenant(body: any, ParamsessionId?: string): Observable<any> {
  
    // const sessionId = ParamsessionId && ParamsessionId.trim() !== ''
    //   ? ParamsessionId
    //   : null;

    // if (!sessionId) {
    //   throw new Error('Session ID is not available');
    // }

    return this.makeAuthenticatedRequestWithValidation<any>(body);
  }


  /**
   * Métodos adicionales para gestión de token auth guardado en el storage
   */
  public isTokenValid(): Observable<boolean> {
    return this.authService.isTokenValid();
  }

  public refreshToken(): void {
    this.authService.refreshToken();
  }

  public clearToken(): void {
    this.authService.clearToken();
  }
}
